import { Sort } from '../types/Sort';

interface Named {
  fullName: string;
}

interface SortMethod<T> {
  (a: T, b: T): -1 | 1 | 0;
}

export const sortByFullName = <T extends Named>(sort: Sort, list: T[]) => {
  switch (sort) {
    case Sort.AlphabeticalAscending:
      return [...list].sort(sortAlphabeticalAscending);
    case Sort.AlphabeticalDescending:
      return [...list].sort(sortAlphabeticalDescending);
  }
  return list;
};

const sortAlphabeticalAscending: SortMethod<Named> = (a, b) => {
  if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) {
    return -1;
  }
  if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) {
    return 1;
  }
  return 0;
};

const sortAlphabeticalDescending: SortMethod<Named> = (a, b) => {
  if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) {
    return -1;
  }
  if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) {
    return 1;
  }
  return 0;
};
